<nav class="navbar bg-body-tertiary">
    <div class="container-fluid">
        <a class="navbar-brand" [routerLink]="['/welcome']">Connect 2.0</a>
        <div class="d-flex">
            <a [routerLink]="['/app']">Login</a>
        </div>
    </div>
</nav>